import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { TOMOS } from '../data/tomos';
export function WhatsIncluded() {
  return <section className="py-9 md:py-16 bg-white" data-id="element-209" data-mp="bxhdkucvwluv">
      <div className="max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210" data-mp="3uanhu4rqhbom">
        <div className="text-center max-w-2xl mx-auto mb-5 md:mb-9" data-id="element-211" data-mp="25jwj6z72zo8">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-2" data-id="element-212" data-mp="23qs7yc20rje">
            La biblioteca clínica
          </p>
          <h2 className="text-[1.35rem] sm:text-3xl md:text-4xl font-black text-clinical-deep mb-2 leading-[1.1] uppercase" data-id="element-213" data-mp="ut7f6ggwng88">
            ¿Qué incluye el Megapack?
          </h2>
          <p className="text-[14px] md:text-base text-clinical-ink leading-snug" data-id="element-214" data-mp="ltatmnptaxhe">
            6 tomos organizados para conectar teoría, práctica y razonamiento
            clínico.
          </p>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4 mb-6 md:mb-9" data-id="element-215" data-mp="36kbbgyc4zn05">
          {TOMOS.map((tomo, idx) => <motion.li key={tomo.num} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          delay: Math.min(idx * 0.04, 0.2),
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col overflow-hidden rounded-xl bg-white border border-clinical-line/80 shadow-[0_4px_14px_rgba(11,42,74,0.07)]" data-id="element-216" data-mp="1wi76ywrlrs0l" data-mpi={idx}>
              <div className="relative w-full overflow-hidden bg-clinical-deep aspect-[4/5] sm:aspect-[3/4]" data-id="element-217" data-mp="2k8b2shyjunh1">
                <img src={tomo.cover} alt={`Tomo ${tomo.num} — ${tomo.title}`} width={600} height={800} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-contain" data-id="element-218" data-mp="2y7u9r7fmjsrr" />
              </div>

              <div className="flex flex-1 flex-col px-2.5 py-2.5 md:px-3.5 md:py-3" data-id="element-219" data-mp="3b73dxbuz7mdd">
                <p className="text-[9px] md:text-[10px] font-bold tracking-[0.16em] uppercase text-clinical-mid mb-0.5" data-id="element-220" data-mp="3fxjqktqz33yo">
                  Tomo {tomo.num}
                </p>
                <h3 className="text-[12.5px] md:text-[14px] font-black text-clinical-deep leading-tight uppercase tracking-wide mb-0.5" data-id="element-221" data-mp="3jyvhd2ll1v8g">
                  {tomo.title}
                </h3>
                <p className="text-[11.5px] md:text-[13px] text-clinical-ink/90 leading-snug" data-id="element-222" data-mp="3txunadeyrcrr">
                  {tomo.desc}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="flex justify-center" data-id="element-223" data-mp="1zld3xgx8wwse">
          <a href="#pricing" className="group inline-flex items-center justify-center gap-2 bg-clinical-cta hover:bg-clinical-ctaHover text-white font-bold text-sm md:text-base px-7 md:px-9 py-4 rounded-full transition-[transform,background-color] duration-200 ease-out hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_28px_rgba(15,98,254,0.32)] w-full max-w-[380px] sm:w-auto uppercase tracking-[0.03em] text-center" data-id="element-224" data-mp="24hlcuckuntr4">
            Quiero acceder a Atlas Clínico
            <ArrowRight size={17} className="transition-transform duration-200 ease-out group-hover:translate-x-1 flex-shrink-0" data-id="element-225" data-mp="14medn07z4tcq" />
          </a>
        </div>
      </div>
    </section>;
}